/**
 * State used in rendering Breadcrumb
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
